import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Client } from '../../http';
import { RootState } from '../../app/store';

/** The free text disclaimers that marketing sets for the signup form. There is only one. */
export interface Disclaimers {
  plans: string;
  checkout: string;
}

export interface disclaimersState {
  value: Disclaimers | null;
  status: 'idle' | 'loading' | 'failed';
}

const initialState: disclaimersState = {
  value: null,
  status: 'idle',
};

export const fetchDisclaimers = createAsyncThunk(
  'disclaimers/fetchDisclaimers',
  async () => {
    const response = await Client.get<Disclaimers>('/api/v1/admin/disclaimers');
    return response.data;
  },
);

export const updateDisclaimers = createAsyncThunk<
  Disclaimers,
  Disclaimers,
  { state: RootState }
>('disclaimers/updateDisclaimers', async (disclaimers: Disclaimers) => {
  const response = await Client.post<Disclaimers>(
    '/api/v1/admin/disclaimers/update',
    disclaimers,
  );
  return response.data;
});

export const disclaimersSlice = createSlice({
  name: 'disclaimers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDisclaimers.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchDisclaimers.fulfilled, (state, action) => {
        state.status = 'idle';
        state.value = action.payload;
      })
      .addCase(fetchDisclaimers.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(updateDisclaimers.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateDisclaimers.fulfilled, (state, action) => {
        state.status = 'idle';
        state.value = action.payload;
      })
      .addCase(updateDisclaimers.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const selectDisclaimers = (state: RootState) => state.disclaimers.value;
export default disclaimersSlice.reducer;
